import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto max-w-screen-2xl" }
const _hoisted_2 = { class: "flex w-full items-end justify-between pb-6" }
const _hoisted_3 = { class: "rounded-3xl bg-sky-blue-200 p-6" }
const _hoisted_4 = {
  key: 2,
  class: "text-center"
}
const _hoisted_5 = {
  key: 3,
  class: "block h-8"
}
const _hoisted_6 = {
  key: 4,
  class: "mt-10 w-full text-center"
}

import { onMounted, watch, nextTick } from "vue";
import { storeToRefs } from "pinia";

import { getTranslation, getGlobalTranslation } from "~/js/composables/translations";
import { useSetQueryParams } from "~/js/composables/query-parameters";

import { animateOverviewGridItems } from "~/js/utils/animation";

import { Translations } from "~/js/interfaces/translations";

import { useTransactionStore } from "~/js/store/transactions";

import Grid from "~/vue/organisms/grids/GridLandings.vue";
import GridSkeleton from "~/vue/organisms/grids/GridSkeleton.vue";
import ButtonLoadMore from "~/vue/atoms/buttons/ButtonLoadMore.vue";
import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import HeaderGrids from "~/vue/molecules/headers/HeaderGrids.vue";
import FilterTransactions from "~/vue/organisms/filters/FilterTransactions.vue";

interface Props {
	translations?: Translations | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewTransactions',
  props: {
    translations: { default: null }
  },
  setup(__props: any) {


const transactionStore = useTransactionStore();
const { transactions, loading, pagination } = storeToRefs(transactionStore);

const onLoadMore = () => {
	transactionStore.fetch(false);
};

watch(transactions, () => {
	if (transactions.value && transactions.value.length > 0) {
		nextTick(() => {
			animateOverviewGridItems();
		});
	}
});

onMounted(async () => {
	await transactionStore.fetch(true, useSetQueryParams());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeaderGrids, {
          heading: _unref(getTranslation)(__props.translations, 'Documents'),
          results: !_unref(loading) ? _unref(pagination).foundResults : null
        }, null, 8, ["heading", "results"]),
        _createElementVNode("div", null, [
          _createVNode(FilterTransactions, { translations: __props.translations }, null, 8, ["translations"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(loading) && !_unref(transactions))
          ? (_openBlock(), _createBlock(GridSkeleton, {
              key: 0,
              size: _unref(pagination).itemsPerPage
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        (_unref(transactions))
          ? (_openBlock(), _createBlock(Grid, {
              key: 1,
              animate: true,
              items: _unref(transactions).map((item) => item.document)
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(transactions) && _unref(transactions).length === 0 && !_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(TextH3, { utilities: "inline-flex items-center space-x-4 mb-4" }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-lg" }, [
                      _createElementVNode("i", { class: "far fa-files" })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(getGlobalTranslation)("No results")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(TextBody, { utilities: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Make your search filter less specific")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true),
        (_unref(pagination).current < _unref(pagination).totalPages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(ButtonLoadMore, {
                title: _unref(getTranslation)(__props.translations, 'Load more transactions'),
                loading: _unref(loading),
                ga: {
							category: 'transactions-load-more',
							action: 'click',
							label: _unref(pagination).current,
						},
                utilities: "mx-auto",
                onClick: onLoadMore
              }, null, 8, ["title", "loading", "ga"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})